import React from 'react';
import PropTypes from 'prop-types';
import SovosMonthSelector from 's1-ui/sovos-month-selector';

const InvoicesPeriodPicker = ({ onChange, yearsBeyond, yearsBefore, selectedMonth, selectedYear }) => {
  const handlePeriodChange = period => onChange(period.year, period.month);
  const actualDate = new Date();

  return (
    <div className={ 'invoices-period-picker' }>
      <SovosMonthSelector
        minDate={ new Date(actualDate.getFullYear() - yearsBefore, 0) }
        maxDate={ new Date(actualDate.getFullYear() + yearsBeyond, 11) }
        format="number"
        onChange={ handlePeriodChange }
        style={ { fontSize: 13 } }
        selectedMonth={ selectedMonth }
        selectedYear={ selectedYear }
      />
    </div>
  );
};

InvoicesPeriodPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  yearsBeyond: PropTypes.number,
  yearsBefore: PropTypes.number,
  selectedMonth: PropTypes.number,
  selectedYear: PropTypes.number
};

InvoicesPeriodPicker.defaultProps = {
  yearsBeyond: 1,
  yearsBefore: 1
};

export default InvoicesPeriodPicker;




// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoicesPeriodPicker/InvoicesPeriodPicker.js